import { decodeToken } from "../DecodeToken";
const CACHE = new Map();
export function getUserId(token) {
    var _a;
    if (!token) {
        return undefined;
    }
    if (CACHE.has(token)) {
        return CACHE.get(token);
    }
    const playerId = (_a = decodeToken(token).PlayerId) === null || _a === void 0 ? void 0 : _a.toString();
    CACHE.set(token, playerId);
    return playerId;
}
//# sourceMappingURL=GetUserId.js.map